import { Injectable, signal } from '@angular/core';

/**
 * Tracks which mobile-header submenu groups are expanded, keyed by a caller-supplied string.
 * Provide it per header component so each brand gets its own instance.
 */
@Injectable()
export class SubmenuToggleState {
    private readonly openKeys = signal<ReadonlySet<string>>(new Set());

    isOpen(key: string): boolean {
        return this.openKeys().has(key);
    }

    /** Opens or closes a group on tap, and stops the click closing the whole Bootstrap dropdown. */
    toggle(key: string, event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        const next = new Set(this.openKeys());
        if (next.has(key)) {
            next.delete(key);
        } else {
            next.add(key);
        }
        this.openKeys.set(next);
    }

    /** Collapses every group, so a reopened dropdown starts closed. */
    reset(): void {
        this.openKeys.set(new Set());
    }
}
